import React from 'react';

import { Star } from 'src/components/atoms/Star';
import { starRatings } from 'src/types/product';
import { roundProductRating } from 'src/utils/rating';
import * as styles from '../styles/starRating.styles';

export interface StarRatingProps {
  productRating: number | null;
  numberOfReviewsCopy?: string;
  numberOfReviews?: number;
  accessibleLabel: string;
}

export const STAR_RATING_CONTAINER_CLASS = 'star-rating__container';
export const STAR_RATING_REVIEWS_CLASS = 'star-rating__reviews';

export const StarRating = ({
  productRating,
  numberOfReviews,
  numberOfReviewsCopy = `(${numberOfReviews})`,
  accessibleLabel,
}: StarRatingProps) => {
  if (!productRating) {
    return null;
  }

  return (
    <div css={styles.starRatingContainer}>
      <div
        className={STAR_RATING_CONTAINER_CLASS}
        css={styles.stars}
        aria-label={accessibleLabel}
        role="img"
      >
        {starRatings.map((rating: number) => (
          <span css={styles.starRating} key={`star-${rating}`}>
            <Star isEmpty={rating > roundProductRating(productRating)} />
          </span>
        ))}
      </div>
      {numberOfReviews && (
        <span className={STAR_RATING_REVIEWS_CLASS} css={styles.reviewsText}>
          {numberOfReviewsCopy}
        </span>
      )}
    </div>
  );
};
